import yup from "src/utils/yup/extensionMethods";

export const addAndChangeSchema = (translate: Function) => yup.object().shape({
	cab001Descricao: yup.string().required(translate("Descrição é requerida")),
	cab001Caa001Id: yup.number().required(translate("Modelo de canvas é requerido")),
	catbb003: yup.array()
		.of(selecUserSchema(translate))
		.min(1,translate("Ao menos uma permissão deve ser informada"))
		.required(translate("Ao menos uma permissão deve ser informada"))
		.unique(translate("Usuários não podem ser repetidos"), (a: any) => a.cab003Efa005Id, (a: any) => !a.cab003Efa004Id)
		.unique(translate("Grupo de usuários não podem ser repetidos"), (a: any) => a.cab003Efa004Id, (a: any) => !a.cab003Efa005Id)
});

export const deleteSchemaCanvas = (translate: Function) => yup.object().shape({
	cab001Descricao: yup.string().required(translate("Nome do canvas não confere")).oneOf([yup.ref("cab001DescricaoConfirmation")], translate("Nome do canvas não confere"))
});


const selecUserSchema = (translate: Function) => yup.object().shape({
	cab003Efa004Id: yup.number()
		.transform((value,originalValue) => originalValue ? value : null)
		.when("cab003Efa005Id",(userId,schema) => !userId ? schema.required(translate("Grupo de usuário é requerido")):schema.nullable()),
	cab003Efa005Id: yup.number()
		.transform((value,originalValue) => originalValue ? value : null)
		.when("cab003Efa004Id",(groupId,schema) => !groupId ? schema.required(translate("Usuário é requerido")): schema.nullable()),
	cab003Permissao:yup.number()
		.required(translate("Opção de permissão é requerida"))
		// .typeError(translate("Opção de permissão está incorreta"))
		.oneOf([0,1,2], translate("Opção invalida"))
},[["cab003Efa005Id","cab003Efa004Id"]]);

export const deleteSchema = (translate: Function) => yup.object().shape({
	rib001Titulo: yup.string().required(translate("Titulo do risco não confere")).oneOf([yup.ref("rib001TituloConfirmation")], translate("Titulo do risco não confere"))
});

